import { SkeletonLoader } from '@moniebook-web/components/atoms/skeleton-loader';
import { mergeClassNames } from '@moniebook-web/utils';

export function MenusLoadingSkeleton() {
    const menu = [1, 2, 3, 4, 5, 6, 7, 8, 'last'];

    return (
        <div className='flex h-full'>
            <div className='flex h-full w-48 flex-col gap-8 border-new-alpha-200 border-r px-8 py-8'>
                <SkeletonLoader width='32px' height='32px' borderRadius='50%' />
                <hr className='border-[0.5px] border-new-alpha-200' />
                <div className='flex h-full flex-col gap-16'>
                    {menu.map((key) => (
                        <div
                            key={key}
                            className={mergeClassNames(
                                key === 'last' && 'mt-auto',
                            )}>
                            <SkeletonLoader
                                width='32px'
                                height='32px'
                                borderRadius='8px'
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div className='flex h-full w-[202px] flex-col gap-8 border-new-alpha-200 border-r px-8 py-8'>
                <div className='flex h-32 items-center justify-start'>
                    <SkeletonLoader
                        width='80%'
                        height='12px'
                        borderRadius='8px'
                    />
                </div>
                <div className='mt-10 flex h-full flex-col gap-16'>
                    {menu.map((key) => (
                        <div
                            key={key}
                            className={mergeClassNames(
                                'flex h-32 items-center',
                                key === 'last' && 'mt-auto',
                            )}>
                            <SkeletonLoader
                                width='70%'
                                height='20px'
                                borderRadius='8px'
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
